import {
  useCompositeStoreOptions,
  useCompositeStoreProps
} from "../__chunks/ACET4OGQ.js";
import "../__chunks/KQUSQ6BH.js";
import {
  useStore
} from "../__chunks/USB5JBON.js";
import "../__chunks/SN2N5P2D.js";
import "../__chunks/UWUL6FFR.js";
import {
  __spreadValues
} from "../__chunks/4BKCJXBM.js";

// src/toolbar/toolbar-store.ts
import * as Core from "@ariakit/core/toolbar/toolbar-store";
function useToolbarStoreOptions(props) {
  return useCompositeStoreOptions(props);
}
function useToolbarStoreProps(store, props) {
  return useCompositeStoreProps(store, props);
}
function useToolbarStore(props = {}) {
  const options = useToolbarStoreOptions(props);
  const store = useStore(
    () => Core.createToolbarStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useToolbarStoreProps(store, props);
}
export {
  useToolbarStore,
  useToolbarStoreOptions,
  useToolbarStoreProps
};
